import { setAuthorizationToken } from "../libs/set_auth_token.utils";
import historyUtils from "../libs/history.utils";
import { serviceGetProfile } from "../services/index.services";
import RouteName from "../routes/Route.name";
import { resetForm } from "./DoctorForm.action";
import { actionGetThemeByDomain } from "./AppSettings.action";

export const AUTH_USER = "AUTH_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_PROFILE = "SET_PROFILE";
export const GET_PROFILE_INIT = "GET_PROFILE_INIT";
export const UPDATE_TOKEN = "UPDATE_TOKEN";

export function actionLoginUser(data) {
  return (dispatch) => {
    if (data) {
      const token = data.token;
      localStorage.setItem("jwt_token", token);
      localStorage.setItem("user", JSON.stringify(data));
      setAuthorizationToken(token);
      dispatch({
        type: AUTH_USER,
        payload: { token: token, name: data.name, id: data.user_id, ...data },
      });
      dispatch(actionGetThemeByDomain());
      if (data?.is_aggrement_accpeted) {
        historyUtils.push(`/`);
      } else {
        historyUtils.push(RouteName.USER_AGGREEMENT);
      }
    }
  };
}

export function actionUpdateToken(data) {
  return (dispatch) => {
    if (data && data.token) {
      const token = data.token;
      localStorage.setItem("jwt_token", token);
      const existingUser = localStorage.getItem("user");
      if (existingUser) {
        const userObj = JSON.parse(existingUser);
        userObj.token = token;
        localStorage.setItem("user", JSON.stringify(userObj));
      }
      setAuthorizationToken(token);
      dispatch({
        type: UPDATE_TOKEN,
        payload: { token },
      });
    }
  };
}

export function actionLogoutUser() {
  return (dispatch) => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user");
    localStorage.removeItem("doctor_form");
    setAuthorizationToken(false);
    dispatch({ type: LOGOUT_USER });
    dispatch(resetForm());
    historyUtils.push(`/login`);
  };
}

export function actionGetProfile() {
  const request = serviceGetProfile();
  return (dispatch) => {
    dispatch({ type: GET_PROFILE_INIT, payload: null });
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: SET_PROFILE, payload: data.data });
      }
    });
  };
}
